import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import {
  VApp,
  VSelect,
  VSimpleCheckbox,
  VSubheader,
  VList,
  VListItem,
  VListGroup,
  VChip
} from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  components: {
    VApp,
    VSelect,
    VSimpleCheckbox,
    VSubheader,
    VList,
    VListItem,
    VListGroup,
    VChip
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        background: '#FFFFFF',
        surface: '#ffffff',
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4caf50',
        warning: '#FFC107',
        textPrimary: '#000000',
        textOnPrimary: '#ffffff',
        customTextColor: '#000000',
        surfaceOpaque: '#FFFFFF'
      },
      dark: {
        background: '#121212',
        surface: '#121212',
        primary: '#2196F3',
        secondary: '#424242',
        accent: '#FF4081',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        textPrimary: '#ffffff',
        textOnPrimary: '#000000',
        customTextColor: '#ffffffff',
        surfaceOpaque: '#121212'
      }
    }
  }
})
